import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resources from './i18n.resources';

// Ne pas charger les ressources ici, nous les chargerons dynamiquement
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // react est déjà sécurisé contre les injections XSS
    },
    
    // Options de détection de langue
    detection: {
      // Pour le développement, utilisez uniquement 'path' pour faciliter les tests
      // En production, vous pouvez revenir à ['path', 'navigator']
      order: ['path'],
      lookupFromPathIndex: 0,
      checkWhitelist: true
    },
    
    react: {
      useSuspense: true,
    },
  });

export default i18n; 